export enum errorMessages {
    somethingWentWrong = 'Something Went wrong',
}

export enum warningMessages {
    sessionExpired = 'Your session has expired. Login again',
}